import React from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { useFormContainerContext } from '../../../Services/FormContainerContext';
import TopFieldContent from '../../Form/components/TopFieldContent';
import ErrorMessage from '../../Form/components/ErrorMessage';
import InputWrapper from '../../Form/components/InputWrapper/InputWrapper';
import DiagnosisSelectSpecial from './DiagnosisSelectSpecial';

interface DiagnosisSelectFieldProps {
	name: string;
	label?: string;
	isRequired?: boolean;
	className?: string;
	portal?: boolean;
	isWrapped?: boolean;
}

const DiagnosisSelectSpecialField: React.FC<DiagnosisSelectFieldProps> = ({
	name,
	label,
	isRequired,
	className,
	portal,
	isWrapped,
}) => {
	const { name: formContainerName } = useFormContainerContext();
	const finalName = formContainerName ? `${formContainerName}.${name}` : name;

	const { control } = useFormContext();
	const {
		field,
		fieldState: { error },
	} = useController({
		control,
		name: finalName,
	});

	const component = (
		<div className={className}>
			{label && <TopFieldContent label={label} isRequired={isRequired} />}
			<DiagnosisSelectSpecial
				value={field.value ?? null}
				onChange={field.onChange}
				portal={portal}
				error={error}
			/>
			{error?.message && <ErrorMessage tx={error.message} />}
		</div>
	);

	if (isWrapped) {
		return <InputWrapper>{component}</InputWrapper>;
	}

	return component;
};

export default DiagnosisSelectSpecialField;
